import enquire from 'enquire.js'
import Flickity from 'flickity'

import Component from '../core/Component.js'
import { CMS, queries } from '../core/config'
import EventBus from '../core/EventBus'
import Scroll from '../services/Scroll'

export const defaults = {
    cellSelector: '[data-ref="item"]',
    prevNextButtons: false,
    pageDots: false,
    cellAlign: 'left',
    autoplay: true,
    lazyLoad: 2,
    responzive: true,
    resize: true,
    dragThreshold: 40,
    adaptiveHeight: true
}

export const STATES = {
    READY: 'is-ready',
    DISABLED: 'is-disabled',
    ACTIVE: 'is-active'
}

export default class ModalSlider extends Component {
    constructor(element, options) {
        super(element, defaults)

        this.ref = {
            slider: null,
            items: [],
            prev: null,
            next: null,
        }

        this.ref.prev = this.element.closest('[data-component="Modal"]').querySelector('[data-ref="ModalSlider:prev"]')
        this.ref.next = this.element.closest('[data-component="Modal"]').querySelector('[data-ref="ModalSlider:next"]')

        this.flickity = null
        this.index = 0
        this.mobile = false

        this.options = options

        this.enquireMediumHandler = {
            match: () => {
                this.mobile = true
            },
            unmatch: () => {
                this.mobile = false
            }
        }
    }

    prepare() {
        if (CMS) {
            return
        }

        EventBus.on('modalopener', this.handleModalOpen)
        Scroll.on('resize', this.handleResize)
        enquire.register(queries.smallWideMax, this.enquireMediumHandler)
    }

    destroy() {
        EventBus.off('modalopener', this.handleModalOpen)
        Scroll.off('resize', this.handleResize)
        enquire.unregister(queries.smallWideMax, this.enquireMediumHandler)
    }

    initSlider() {
        if (!this.flickity) {
            this.element.classList.add(STATES.READY)

            this.flickity = new Flickity(this.ref.slider, this.options)

            this.ref.prev.addEventListener('click', this.previous)
            this.ref.next.addEventListener('click', this.next)

            this.flickity.on('change', ::this.changeSlide );

            this.handleResize()

            this.scrollContainer = Component.getFromElement(this.element.closest('[data-ref="Modal:scrollContainer"]'))
        }
    }

    destroySlider() {
        if (this.flickity) {
            this.element.classList.remove(STATES.READY)

            this.flickity.off('change', ::this.changeSlide);

            this.flickity.destroy()
            this.flickity = null

            this.ref.prev.removeEventListener('click', this.previous)
            this.ref.next.removeEventListener('click', this.next)
        }
    }

    handleModalOpen = modal => {
        if (modal.id == "brand-modal" || modal.id == "restaurant-modal") {
            this.initSlider()
            this.flickity.select(modal.element.dataset.slideId, false, true)
        }
    }

    changeSlide(index) {
        if (index == 0) {
            this.ref.prev.classList.add(STATES.DISABLED)
        } else {
            this.ref.prev.classList.remove(STATES.DISABLED)
        }

        if (index >= this.flickity.slides.length-1) {
            this.ref.next.classList.add(STATES.DISABLED)
        } else {
            this.ref.next.classList.remove(STATES.DISABLED)
        }

        if (!this.mobile) {
            this.resizeViewport(this.ref.items[index])
        }

        this.index = index

        //this.scrollContainer?.scrollbar?.scrollTo(0, 100, 300)
    }

    next = event => {
        event.preventDefault()
        this.flickity.next()
    }

    previous = event => {
        event.preventDefault()
        this.flickity.previous()
    }

    handleResize = () => {
        let currElement
        let max = 0

        this.ref.items.forEach($element => {
            let $innerBox = $element.querySelector('.hotel-Detail')

            if ($element.classList.contains(STATES.ACTIVE)) {
                currElement = $innerBox
            }

            if ($element.scrollHeight > max) {
                max = $element.scrollHeight
            }
        })

        if (!this.mobile) {
            this.resizeViewport(currElement)
        } else {
            this.ref.slider.style.height = max + 'px'
        }
    }

    resizeViewport($element) {
        this.ref.slider.style.height = $element.scrollHeight + 'px'

        if (this.scrollContainer?.scrollbar) {
            setTimeout(() => {
                this.scrollContainer.scrollbar.scrollTo(0, 0, 100)
                this.scrollContainer.scrollbar.update()
            }, 300)
        }
    }
}
